import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import HttpAxios from '../../commons/hooks/http';
import enviroment from '../../enviroments/enviroment';
import {
    EEmail,
    EName,
    ELastName,
    EPassword,
    EPosition,
    EPhone,
    EErrorMsg,
    ESuccessMsg,
} from '../../commons/statics/controls';
import { useUserMe } from '../../commons/hooks/userme';
import { IUser, IUserMe } from '../../commons/interfaces/user';
import { AppContext } from '../../commons/context/App-context';
import IconArrowLeft from '../../images/arrow-left-blue.svg';
import './profile.scss';

const Profile = () => {
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [userMe, setUserMe] = useUserMe();
    const [msgError, setMsgError] = useState('');
    const history = useHistory();
    const { register, handleSubmit, formState, getValues } = useForm({
        mode: 'onChange',
    });
    const { errors, isDirty, isValid } = formState;
    const [msgSuccess, setMsgSuccess] = useState('');

    const handleOnSubmit = (u: IUser) => {
        setMsgSuccess('');
        setMsgError('');
        const {
            name,
            lastName,
            email,
            phone,
            position,
            password = '',
            rePassword,
        } = u;
        changeIsLoading(true);

        if (name && lastName && email && phone && position) {
            if (password === rePassword) {
                setMsgError('');
                const dataToUpdate = {
                    nombre: name,
                    apellido: lastName,
                    email,
                    password,
                    cargo: position,
                    telefono: phone,
                };
                HttpAxios.put(enviroment.apiURL + '/user/me', dataToUpdate)
                    .then((res: any) => {
                        const { err } = res?.data || {};
                        changeIsLoading(false);
                        if (err) {
                            setMsgError(err);
                        } else {
                            let userMeUpdated = (userMe as IUserMe) || {};

                            setUserMe({ ...userMeUpdated, ...dataToUpdate });
                            setMsgSuccess(ESuccessMsg.profile);
                        }
                    })
                    .catch(() => {
                        changeIsLoading(false);
                        setMsgError(EErrorMsg.generic);
                    });
            } else {
                changeIsLoading(false);
                setMsgError(EErrorMsg.confirmPassword);
            }
        } else {
            changeIsLoading(false);
            setMsgError(EErrorMsg.dataForm);
        }
    };

    const handleBack = () => {
        history.push('/');
    };

    return (
        <div
            className="RegisterWrapFull"
            style={{
                backgroundImage:
                    'url(/images/profile-left.png)',
            }}
        >
            <div className="RegisterLogo">
                <img
                    alt="Empresas que transforman el Perú"
                    src="/images/logo.png"
                />
            </div>
            <div className="RegisterBack">
                <button
                    type="button"
                    className="button buttonText"
                    onClick={handleBack}
                >
                    <img
                        src={IconArrowLeft}
                        alt=""
                        className="buttonIconLeft"
                    />
                    Regresar
                </button>
            </div>
            <div className="RegisterWrap">
                <form
                    onSubmit={handleSubmit(handleOnSubmit)}
                    className="RegisterWrapInner"
                >
                    <h4 className="RegisterTitle">
                        Edita tu perfil de postulante
                    </h4>
                    <div className="RegisterWrapForm">
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors?.name,
                                })}
                                htmlFor="name"
                            >
                                Nombres
                            </label>
                            <input
                                defaultValue={userMe?.nombre || ''}
                                className={classnames({
                                    input: true,
                                    invalid: errors?.name,
                                })}
                                id="name"
                                type="text"
                                placeholder="Ingresa tu nombre"
                                maxLength={EName.maxLength}
                                {...register('name', {
                                    required: {
                                        value: true,
                                        message: 'Nombre es requiredo.',
                                    },
                                    minLength: {
                                        value: EName.minLength,
                                        message:
                                            'Min. ' +
                                            EName.minLength +
                                            ' Caracteres.',
                                    },
                                    maxLength: {
                                        value: EName.maxLength,
                                        message:
                                            'Max. ' +
                                            EName.maxLength +
                                            ' Caracteres.',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.name && errors?.name?.message}
                            </div>
                        </div>
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors?.lastName,
                                })}
                                htmlFor="lastName"
                            >
                                Apellidos
                            </label>
                            <input
                                defaultValue={userMe?.apellido || ''}
                                className={classnames({
                                    input: true,
                                    invalid: errors?.lastName,
                                })}
                                id="lastName"
                                type="text"
                                placeholder="Ingresa tus apellidos"
                                maxLength={ELastName.maxLength}
                                {...register('lastName', {
                                    required: {
                                        value: true,
                                        message: 'Apellido es requerido.',
                                    },
                                    minLength: {
                                        value: ELastName.minLength,
                                        message:
                                            'Min. ' +
                                            ELastName.minLength +
                                            ' caracteres.',
                                    },
                                    maxLength: {
                                        value: ELastName.maxLength,
                                        message:
                                            'Max. ' +
                                            ELastName.maxLength +
                                            ' caracteres.',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.lastName && errors?.lastName?.message}
                            </div>
                        </div>
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors?.position,
                                })}
                                htmlFor="position"
                            >
                                Cargo
                            </label>
                            <input
                                defaultValue={userMe?.cargo || ''}
                                className={classnames({
                                    input: true,
                                    invalid: errors?.position,
                                })}
                                id="position"
                                type="text"
                                placeholder="Ingresa tu Cargo"
                                maxLength={EPosition.maxLength}
                                {...register('position', {
                                    required: {
                                        value: true,
                                        message: 'Cargo es requerido.',
                                    },
                                    minLength: {
                                        value: EPosition.minLength,
                                        message:
                                            'Min. ' +
                                            EPosition.minLength +
                                            ' caracteres.',
                                    },
                                    maxLength: {
                                        value: EPosition.maxLength,
                                        message:
                                            'Max. ' +
                                            EPosition.maxLength +
                                            ' caracteres.',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.lastName && errors?.lastName?.message}
                            </div>
                        </div>
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors?.email,
                                })}
                                htmlFor="email"
                            >
                                Mail corporativo
                            </label>
                            <input
                                defaultValue={userMe?.email || ''}
                                className={classnames({
                                    input: true,
                                    invalid: errors?.email,
                                })}
                                id="email"
                                type="text"
                                placeholder="Ingresa tu mail corporativo"
                                maxLength={EEmail.maxLength}
                                {...register('email', {
                                    required: {
                                        value: true,
                                        message: 'Email es requerido.',
                                    },
                                    pattern: {
                                        value: EEmail.pattern,
                                        message:
                                            'Ingresa un Mail corporativo válido.',
                                    },
                                    minLength: {
                                        value: EEmail.minLength,
                                        message:
                                            'Min. ' +
                                            EEmail.minLength +
                                            ' caracteres.',
                                    },
                                    maxLength: {
                                        value: EEmail.maxLength,
                                        message:
                                            'Max. ' +
                                            EEmail.maxLength +
                                            ' caracteres.',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.email && errors?.email?.message}
                            </div>
                        </div>
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors?.phone,
                                })}
                                htmlFor="phone"
                            >
                                Teléfono de contacto
                            </label>
                            <input
                                defaultValue={userMe?.telefono || ''}
                                className={classnames({
                                    input: true,
                                    invalid: errors?.phone,
                                })}
                                id="phone"
                                type="input"
                                placeholder="Teléfono de contacto"
                                maxLength={EPhone.maxLength}
                                {...register('phone', {
                                    required: {
                                        value: true,
                                        message: 'Teléfono es requerido.',
                                    },
                                    minLength: {
                                        value: EPhone.minLength,
                                        message:
                                            'Min. ' +
                                            EPhone.minLength +
                                            ' números.',
                                    },
                                    maxLength: {
                                        value: EPhone.maxLength,
                                        message:
                                            'Max. ' +
                                            EPhone.maxLength +
                                            ' números.',
                                    },
                                    pattern: {
                                        value: EPhone.pattern,
                                        message: 'Ingresa un Teléfono válido',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.phone && errors?.phone?.message}
                            </div>
                        </div>
                        <div className="mbm">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors.password,
                                })}
                                htmlFor="password"
                            >
                                Contraseña
                            </label>
                            <input
                                className={classnames({
                                    input: true,
                                    invalid: errors.password,
                                })}
                                id="password"
                                type="password"
                                placeholder="Mínimo 6 caracteres"
                                maxLength={EPassword.maxLength}
                                {...register('password', {
                                    required: {
                                        value: false,
                                        message: 'Contraseña es requerida.',
                                    },
                                    minLength: {
                                        value: EPassword.minLength,
                                        message:
                                            'Min. ' +
                                            EPassword.minLength +
                                            ' caracteres.',
                                    },
                                    maxLength: {
                                        value: EPassword.maxLength,
                                        message:
                                            'Max. ' +
                                            EPassword.maxLength +
                                            ' caracteres.',
                                    },
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.password && errors?.password?.message}
                            </div>
                        </div>
                        <div className="mb1">
                            <label
                                className={classnames({
                                    label: true,
                                    invalid: errors.rePassword,
                                })}
                                htmlFor="rePassword"
                            >
                                Confirma tu contraseña
                            </label>
                            <input
                                className={classnames({
                                    input: true,
                                    invalid: errors.rePassword,
                                })}
                                id="rePassword"
                                type="password"
                                placeholder="Confirma tu contraseña"
                                maxLength={EPassword.maxLength}
                                {...register('rePassword', {
                                    required: {
                                        value: false,
                                        message:
                                            'Confirma tu contraseña es requerida.',
                                    },
                                    minLength: {
                                        value: EPassword.minLength,
                                        message:
                                            'Min. ' +
                                            EPassword.minLength +
                                            ' caracteres.',
                                    },
                                    maxLength: {
                                        value: EPassword.maxLength,
                                        message:
                                            'Max. ' +
                                            EPassword.maxLength +
                                            ' caracteres.',
                                    },
                                    validate: (val) =>
                                        val === getValues('password') ||
                                        EErrorMsg.confirmPassword,
                                })}
                            />
                            <div className="helpText invalid">
                                {errors?.rePassword &&
                                    errors?.rePassword?.message}
                            </div>
                        </div>
                        <div className="mb1">
                            <button
                                className="button buttonFit"
                                type="submit"
                                disabled={isLoading || !isDirty || !isValid}
                            >
                                Regístrate
                            </button>
                        </div>
                        {msgError && (
                            <div className="mb1 helpText invalid">
                                {msgError}
                            </div>
                        )}
                        {msgSuccess && (
                            <div className="mb1 helpText valid">
                                {msgSuccess}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Profile;
